import { errorHandlerm, iRequest } from '../utils/requestutil';

export async function query(payload) {
  return iRequest(`/iwms-basic/basic/dc/page`, {
    method: 'POST',
    body: payload,
  });
}
